import { Icon } from 'assets/index'
import {
  InfoCard,
  MaskedInput2,
  PinConfirmation,
  ResumeInputCard,
} from 'components/index'
import * as Yup from 'yup'
import { useContext, useEffect, useRef, useState } from 'react'
import { useStorage, useFetch } from 'hooks'
import { logoSmallBlack, logoSmallWhite } from 'assets/Icons'
import { Form } from '@unform/web'
import { Simulacao } from 'pages/index'
import { UserContext } from 'context/userContext'
import { IMAGES } from 'configs/configs.js'
import { IMask } from 'react-imask'
import useAuth from 'hooks/useAuth'
import { Theme } from 'styles/Themes'
import {
  dateToInterDate,
  hasAccess,
  moneyToNumber,
  maskPhone,
} from 'helper/utils'
import { IResponse } from 'interfaces'
import { useNavigate } from 'react-router-dom'
import html2pdf from 'html2pdf.js'
import { PixButton, Simulation, PixContainer } from './style'

const mask = {
  d: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2,
  },
  m: {
    mask: IMask.MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2,
  },
  Y: {
    mask: IMask.MaskedRange,
    from: 1900,
    to: 2100,
  },
}

export function Info(props: any) {
  const { token } = props
  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Informações da captação</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('cash_min.svg')} value={token?.name}>
          Nome completo da captação
        </InfoCard>
        <InfoCard icon={Icon('cash.svg')} value={token?.shortName}>
          Nome resumido da captação
        </InfoCard>
        <InfoCard icon={Icon('cash.svg')} value={token?.tick}>
          Sigla do produto
        </InfoCard>
        <InfoCard icon={Icon('cash.svg')} value={token?.type}>
          Tipo de investimento
        </InfoCard>
        <InfoCard
          icon={Icon('calendar.svg')}
          value={token?.guarantee?.join(',')}
        >
          Garantia
        </InfoCard>
      </div>
    </>
  )
}

export function InvestmentInfo(props: any) {
  const { token, data } = props
  const [colaboradores] = useStorage('Colaboradores')
  // const specialistList = general.gestor.get()
  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Detalhes da captação</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('lock_open.svg')} value={token?.captionType}>
          Modalidade da captação
        </InfoCard>
        <InfoCard
          icon={`${IMAGES.URL}/images/${
            colaboradores.find((item: any) => item.id === token?.gestorId)
              ?.profilePic
          }`}
          value={
            colaboradores.find((item: any) => item.id === token?.gestorId)?.name
          }
          pic
          width={250}
        >
          Especialista
        </InfoCard>
        <InfoCard icon={Icon('cash.svg')} value={data?.contract?.status}>
          Status
        </InfoCard>
      </div>
    </>
  )
}

export function InvestmentCondit(props: any) {
  const { data } = props
  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Condições do investimento</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('cash.svg')} value={data.contract?.quotaValue}>
          Preço da cota
        </InfoCard>
        <InfoCard icon={Icon('cash.svg')} value={data.contract?.quotaAmount}>
          Cotas compradas
        </InfoCard>
        <InfoCard
          tertiary
          textWhite
          icon={Icon('cash_min.svg')}
          value={data?.contract?.invested}
        >
          Valor do investimento
        </InfoCard>
      </div>
    </>
  )
}

const schemaPix = Yup.object().shape({
  pixAmount: Yup.number()
    .typeError('Deve ser um valor válido')
    .min(1)
    .typeError('Mínimo de R$ 1,00')
    .required('Campo obrigatório'),
})

interface ValidationErrors {
  [key: string]: string
}

export function Condition(props: any) {
  const {
    token,
    contract,
    enterprise,
    noPix,
    notClickable = false,
    contractId,
    setData,
  } = props
  const { selectedId, setShowModal } = useContext(UserContext)
  const [pix, setPix] = useState<boolean | string>(false)
  const [pixAmount, setPixAmount] = useState<any>()
  const api = useFetch()
  const navigate = useNavigate()
  const { setToken } = useAuth()
  const [investedValue, setInvestedValue] = useState<string>(contract?.invested)
  const [showPinConfirmation, setShowPinConfirmation] = useState(false)
  const [refreshKey, setRefreshKey] = useState(0) // Estado para forçar re-renderização
  const userIsFinancial = hasAccess('edit-valorDoInvestimento-financial')
  const formRef = useRef<HTMLFormElement | any>(null)
  const [pinText, setPinText] = useState({})

  const generatePix = async () => {
    try {
      formRef.current.setErrors({})
      await schemaPix.validate(pixAmount, { abortEarly: false })
      setPix('loading')

      const r = await api.fetch(
        'get',
        null,
        `/gestor/contract/pix-key/${selectedId.current}?value=${pixAmount?.pixAmount}`
      )
      setPix(true)
      if (r.fail) {
        console.log(r)
        formRef.current.setErrors({ pixAmount: r.errors.message })
        setPix(false)
      }
      navigator.clipboard.writeText(r.data.data.key)
      setTimeout(() => {
        setPix(false)
      }, 3000)
    } catch (err) {
      console.error(err)
      const validationErrors: ValidationErrors = {}
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path) {
            validationErrors[error.path] = error.message
          }
        })
        console.error('Validations', validationErrors)
        formRef.current.setErrors(validationErrors)
      }
    }
  }

  const content = {
    0: {
      title: 'Código de verificação',
      titleTxt: [
        `Digite o código de 4 dígitos que te enviamos por`,
        `SMS no número ${maskPhone(contract?.cellphone)}`,
      ],
      icon: 'check_circle.svg',
    },
    1: {
      title: 'Conta Bloqueada',
      titleTxt: [
        'A solicitação de edição de valor foi reprovada.',
        'Sua conta foi bloqueado devido a atividades suspeitas.',
        'Contate o suporte para recuperação.',
      ],
      icon: 'x_circle.svg',
    },
    2: {
      title: 'Edição de valor aprovada',
      titleTxt: [
        `Verificação feita com sucesso! `,
        `Sua solicitação de edição foi realizada`,
        `Acompanhe a repercussão da sua alteração.`,
      ],
      icon: 'check_circle.svg',
    },
    3: {
      title: 'Erro de solicitação',
      titleTxt: [
        `Houve uma falha ao enviar dados ao servidor `,
        `Tente novamente mais tarde`,
      ],
      icon: 'x_circle.svg',
    },
  }

  useEffect(() => {
    setPinText(content)
  }, [])

  const updateValorInvestimento = async (pin: string | number) => {
    try {
      const response: IResponse = await api.fetch(
        'put',
        {
          totalPaid: moneyToNumber(investedValue),
          code: pin,
        },
        `/gestor/private_contract?id=${contractId}`
      )

      if (!response || response.fail) {
        response.errors.message &&
          setPinText((last) => ({
            ...last,
            3: {
              title: 'Erro de solicitação',
              titleTxt: [response?.errors?.message],
              icon: 'x_circle.svg',
            },
          }))
        return 3
      }

      setData((prev: any) => ({
        ...prev,
        token: {
          ...prev.token,
          mountlyProjectedToPay: response.data.data.token.mountlyProjectedToPay,
          expectedToPay: response.data.data.token.expectedToPay,
          projectedToPay: response.data.data.token.projectedToPay,
        },
      }))
      // Atualiza estados dos detalhes de acordo com o valor investido

      return 2
    } catch (err) {
      console.log(err)
      return 3
    }
  }

  const disablePix =
    !contract?.hasPix ||
    ['CANCELED', 'BURNED', 'MIGRATED'].includes(token?.status) ||
    noPix ||
    !hasAccess('copy-pix-key')

  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Condições da captação</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('cash.svg')} value={token?.price}>
          Preço da cota
        </InfoCard>
        <InfoCard
          icon={Icon('cash.svg')}
          value={
            token?.holderList?.length === 0 ? token?.sold : token?.available
          }
        >
          {token?.holderList?.length === 0
            ? 'Cotas vendidas nesta captação'
            : 'Cotas disponíveis para essa captação'}
        </InfoCard>
        <InfoCard icon={Icon('aim.svg')} value={token?.expected}>
          Meta de captação
        </InfoCard>
        <InfoCard icon={Icon('cash_min.svg')} value={token?.min}>
          Investimento mínimo
        </InfoCard>

        {contract?.invested && (
          <ResumeInputCard
            filter={Theme.icons.PRIMARY}
            key={refreshKey}
            green
            names="resumo-meta-captacao"
            icon="cash_min.svg"
            isMask="R$ num"
            clickable={!notClickable && userIsFinancial} // userIsFinancial
            blocks={{
              num: {
                mask: Number,
                radix: ',',
                mapToRadix: [','], // accepts both '.' and ',' but maps to '.'
                scale: 2,
                signed: false,
                thousandsSeparator: '.',
                padFractionalZeros: true,
                normalizeZeros: true,
                min: 0,
                max: Number.MAX_SAFE_INTEGER,
              },
            }}
            placeholder={contract?.invested}
            onClickOK={() => {
              api.fetch('get', null, `/gestor/send-sms-code`)
              setShowPinConfirmation(true)
            }}
            handleChangeInput={(e: string) => {
              setInvestedValue(e)
            }}
          >
            Valor do investimento
          </ResumeInputCard>
        )}
        {showPinConfirmation && (
          <PinConfirmation
            handleSend={updateValorInvestimento}
            setShowPinConfirmation={setShowPinConfirmation}
            setKey={setRefreshKey}
            content={pinText}
            setContent={setPinText}
            confirmButton="Alterar dado"
          />
        )}
        <InfoCard
          secondary
          icon={Icon('cash.svg')}
          value={enterprise?.available}
        >
          Cotas disponíveis do empreendimento
        </InfoCard>
        <InfoCard
          icon={Icon('calendar.svg')}
          value={`${token?.icoPeriod} dias`}
        >
          Período de captação
        </InfoCard>
        {token?.holderList?.length !== 1 && (
          <InfoCard
            secondary
            icon={Icon('profile.svg')}
            value={token?.holderAmount}
          >
            Investidores
          </InfoCard>
        )}
        <PixContainer>
          <Form ref={formRef} onSubmit={() => console.log('submit')}>
            <MaskedInput2
              uniqKey={`input_pix_qrcode`}
              small
              hasAsterisk
              dataTestId="investiment-value-pix"
              type="money"
              handleChange={(e: any) => {
                setPixAmount({ pixAmount: e })
              }}
              placeholder={'Valor do depósito'}
              name="pixAmount"
              defaultValue={pixAmount}
              disabled={disablePix}
            />
          </Form>
          <PixButton
            disabled={disablePix}
            onClick={generatePix}
            id={'copy-pix-key'}
          >
            {pix === 'loading' ? (
              <div>
                <img
                  className="loading-img-btn"
                  src={logoSmallWhite}
                  alt="card icon"
                />
              </div>
            ) : (
              <>
                <img
                  className="default-btn-img"
                  src={pix ? Icon('check_circle.svg') : Icon('link.svg')}
                  alt="copy to clip"
                />
                <span>{pix ? 'Chave pix copiada' : 'Copiar chave pix'}</span>
              </>
            )}
          </PixButton>
        </PixContainer>
      </div>
    </>
  )
}

export function Contract(props: any) {
  const { token, contract } = props
  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Informações do contrato</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('lock_open.svg')} value={token?.deadline}>
          Prazo do contrato
        </InfoCard>
        <InfoCard icon={Icon('lock_open.svg')} value={token?.recurrencyType}>
          Pagamento de juros
        </InfoCard>
        <InfoCard
          icon={Icon('shield.svg')}
          value={token?.principalLiquidityType}
        >
          Liquidez
        </InfoCard>
        {contract?.quotaAmount && (
          <InfoCard icon={Icon('lock_open.svg')} value={contract?.quotaAmount}>
            Total de cotas
          </InfoCard>
        )}
        {contract?.customData?.distribution &&
          contract?.customData?.distribution.map((item: any) => {
            return (
              <InfoCard icon={Icon('lock_open.svg')} value={`${item[2]} cotas`}>
                Unidade {item[0]}
              </InfoCard>
            )
          })}
      </div>
    </>
  )
}

export function Rental(props: any) {
  const { token } = props
  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Condições da rentabilidade</h4>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('invest.svg')} value={token?.paymentType}>
          Indexador
        </InfoCard>
        {token?.indice?.label && (
          <InfoCard icon={Icon('percentage.svg')} value={'IPCA +'}>
            Índice
          </InfoCard>
        )}
        <InfoCard
          icon={Icon('percentage.svg')}
          value={`${token?.profitability?.toFixed(2)}%`}
        >
          Juros a.a.
        </InfoCard>
        <InfoCard icon={Icon('percentage.svg')} value={token?.IRType}>
          Imposto de renda
        </InfoCard>
        <InfoCard icon={Icon('login.svg')} value={`D + ${token?.cotizationIn}`}>
          Período de cotização de entrada
        </InfoCard>
        <InfoCard
          icon={Icon('login.svg')}
          value={`D + ${token?.cotizationOut}`}
        >
          Período de cotização de saída
        </InfoCard>
        <InfoCard
          icon={Icon('login.svg')}
          value={token?.isCotizationProfitable ? 'Sim' : 'Não'}
        >
          Cotização de saída rentabilizada
        </InfoCard>
      </div>
    </>
  )
}

export function Dates(props: any) {
  const { token, isInvesment, data, edit, setData, contractId } = props
  const api = useFetch()
  const [clickable, setClickable] = useState<any>()
  const [loadingp, setLoadingp] = useState<any>(false)
  const [text, setText] = useState<string>('')

  const handleUpdate = (body: any) => {
    return new Promise((resolve) => {
      api
        .fetch(
          'put',
          body,
          `/gestor/private_contract?id=${
            contractId
            // selectedId.current.id || selectedId.current.contractId
          }`
        )
        .then(resolve)
        .catch((reject1) => {
          console.error(reject1)
        })
    })
  }

  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Datas</h4>
      <div className="status-card-container-cards">
        {!isInvesment ? (
          <InfoCard icon={Icon('calendar.svg')} value={token?.createdAt}>
            Data de emissão
          </InfoCard>
        ) : edit ? (
          <ResumeInputCard
            onClickEdit={() => setClickable('investedAt')}
            loading={loadingp === 'investedAt'}
            clickable={!clickable || clickable === 'investedAt'}
            names="birthday"
            icon="calendar.svg"
            isMask="d/m/Y"
            blocks={mask}
            placeholder={data.contract?.investedAt}
            small
            onClickOK={() => {
              if (text.length === 0) return
              setLoadingp('investedAt')
              handleUpdate({ investedAt: dateToInterDate(text) }).then(
                (r: any) => {
                  setData((old: any) => ({
                    ...old,
                    contract: {
                      ...old.contract,
                      ...r?.data?.data?.contract,
                    },
                  }))
                  setLoadingp(false)
                  setClickable(false)
                }
              )
            }}
            handleChangeInput={(e: string) => {
              setText(e)
            }}
          >
            Data de investimento
          </ResumeInputCard>
        ) : (
          <InfoCard
            icon={Icon('calendar.svg')}
            value={data.contract?.investedAt}
          >
            Data de investimento
          </InfoCard>
        )}
        <InfoCard icon={Icon('calendar.svg')} value={token?.releaseAt}>
          Data de lançamento
        </InfoCard>
        {token?.recurrencyType === 'DEFAULT' ||
          (edit ? (
            <ResumeInputCard
              onClickEdit={() => setClickable('startedAt')}
              loading={loadingp === 'startedAt'}
              clickable={!clickable || clickable === 'startedAt'}
              names="birthday"
              icon="calendar.svg"
              isMask="d/m/Y"
              blocks={mask}
              placeholder={data.contract?.startedAt}
              small
              onClickOK={() => {
                if (text.length === 0) return
                setLoadingp('startedAt')
                handleUpdate({ startedAt: dateToInterDate(text) }).then(
                  (r: any) => {
                    setData((old: any) => ({
                      ...old,
                      contract: {
                        ...old.contract,
                        ...r?.data?.data?.contract,
                      },
                    }))
                    setLoadingp(false)
                    setClickable(false)
                  }
                )
              }}
              handleChangeInput={(e: string) => {
                setText(e)
              }}
            >
              Início do pagamento
            </ResumeInputCard>
          ) : (
            <InfoCard
              icon={Icon('calendar.svg')}
              value={
                isInvesment ? data?.contract?.startedAt : token?.firstPayment
              }
            >
              Início do pagamento
            </InfoCard>
          ))}
        <InfoCard
          icon={Icon('calendar.svg')}
          value={isInvesment ? data?.contract?.lastAt : token?.lastPayment}
        >
          Último pagamento
        </InfoCard>
        <InfoCard
          icon={Icon('calendar.svg')}
          value={
            isInvesment ? data?.contract?.rescueAt : token?.principalPayment
          }
        >
          Retorno do principal
        </InfoCard>
      </div>
    </>
  )
}

export function Payments(props: any) {
  const { token, contract } = props

  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Pagamentos</h4>
      <div className="status-card-container-cards">
        <InfoCard
          tertiary={token?.status === 'Rentabilizando'}
          textWhite={token?.status === 'Rentabilizando'}
          disabled={token?.status !== 'Rentabilizando'}
          icon={Icon('money.svg')}
          value={token?.totalPaid}
        >
          Rentabilidade paga
        </InfoCard>
        <InfoCard icon={Icon('money.svg')} value={token?.mountlyProjectedToPay}>
          {`Projeção de pagamento ${
            token?.recurrencyType?.toLowerCase() || 'mensal'
          }`}
        </InfoCard>
        <InfoCard icon={Icon('money.svg')} value={token?.projectedToPay}>
          Rentabilidade projetada
        </InfoCard>
        {!contract &&
          token?.contract?.parcel !== undefined &&
          token?.contract?.totalParcel !== undefined &&
          !Number.isNaN(token?.contract?.parcel) &&
          !Number.isNaN(token?.contract?.totalParcel) && (
            <InfoCard
              icon={Icon('calendar.svg')}
              value={`${token?.contract?.parcel} de ${token?.contract?.totalParcel}`}
            >
              Parcela
            </InfoCard>
          )}
        {!contract && (
          <InfoCard
            secondary
            textWhite
            icon={Icon('money.svg')}
            value={token?.expectedToPay}
          >
            Rentabilidade a pagar
          </InfoCard>
        )}
        {!contract && token?.contract && (
          <InfoCard
            icon={Icon('money.svg')}
            value={`${token?.contract?.rate}%`}
          >
            Pagamento
          </InfoCard>
        )}
        {(token?.holderList?.length > 0 || !contract) &&
          token?.captionType === 'Fechada' && (
            <>
              <InfoCard
                disabled
                icon={Icon('money.svg')}
                value={`${token?.cotizationOut} dias`}
              >
                Período de resgate
              </InfoCard>
              <InfoCard
                icon={Icon('money.svg')}
                value={token?.deadlineRemaining}
              >
                Prazo para o vencimento
              </InfoCard>
            </>
          )}
      </div>
    </>
  )
}

export function Bonus(props: any) {
  const { data } = props

  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Bônus de contrato</h4>
      <div className="status-card-container-cards">
        <InfoCard
          icon={Icon('percentage.svg')}
          // value={`${token?.profitabilityBonus}%`}
          // value={`0,6%`}
          value={data?.rate}
        >
          Juros ao mês
        </InfoCard>
        <InfoCard
          icon={Icon('lock_open.svg')}
          // value={token?.deadlineBonus}
          // value={`14 meses`}
          value={data?.qtd}
        >
          Meses
        </InfoCard>
        <InfoCard
          icon={Icon('money.svg')}
          // value={token?.mountlyProjectedBonus}
          // value={`R$ 190,00`}
          value={data?.value}
        >
          Pagamento mensal de bônus
        </InfoCard>
        <InfoCard
          icon={Icon('money.svg')}
          // value={`1.900,00`}
          value={data?.total}
          // value={token?.ProjectedBonus}
        >
          Total do bônus
        </InfoCard>
        {data.remains && (
          <InfoCard
            icon={Icon('money.svg')}
            value={data.remains}
            // Trocar para o valor bonus a pagar
          >
            Bônus a pagar
          </InfoCard>
        )}
      </div>
    </>
  )
}

export function Simula(props: any) {
  const [load, setLoad] = useState<boolean | string>(false)
  const [info, setInfo] = useState({ table1: [], table2: [] })
  const api = useFetch()
  const { id, name, value, isInsento } = props

  const generatePdf = () => {
    setLoad(true)
    api
      .fetch('get', null, `/token/simulate/${id}?value=${moneyToNumber(value)}`)
      .then((r) => {
        setInfo({ isInsento, name, ...r.data })
        const element = document.getElementById('pdf-content')
        const opt = {
          margin: 5,
          filename: 'Proposta.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 3 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
          // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        }

        setTimeout(() => {
          html2pdf()
            .from(element)
            .set(opt)

            .save()
          setLoad(false)
        }, 1000)
        // console.log(info)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  return <div />
}

/*
;<Simulation>
  <div className="row">
    <p className="title">Simulação do investimento</p>
    {/* <img
          alt="doc-icon"
          src={Icon('doc.svg')}
          className="d-icons"
          onClick={() => {
            generatePdf()
          }}
        /> 
    <img
      alt="download-icon"
      className="d-icons"
      src={Icon('login.svg')}
      style={{ transform: 'rotate(270deg)' }}
      onClick={() => {
        generatePdf()
      }}
    />
  </div>
  <div className="big-pdf-button">
    {load ? (
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
        }}
      >
        <img className="loading-img-btn" src={logoSmallBlack} alt="card icon" />
      </div>
    ) : (
      <>
        <img
          alt="download-icon"
          className="big-pdf-icon"
          src={Icon('PDF.svg')}
        />
        <p>Proposta.PDF</p>
      </>
    )}
  </div>
  <div style={{ display: 'none' }}>
    <Simulacao info={info} />
  </div>
</Simulation>
*/
